import { apiBeAuth } from "@/entities/auth";

// DCA 미체결 주문 설정 변경
export const PutDcaSetting = async (data: PutDcaSettingReq) => {
  const responseBody = await apiBeAuth<PutDcaSettingRes>("/user/dca/setting/detail", {
    method: "PUT",
    body: JSON.stringify(data),
  });

  return responseBody;
};
